<template>
  <div>
   
    <autoLogout />
    <loader :loader="sending" />
    <div class="wrapper-content">
      <encabezado :elementos="encabezado" v-if="showAction(1)"/>
      <v-card v-if="showAction(1)">
        <v-card-text>
          <v-row align="baseline" justify="center" class="pb-4">
            <v-col cols="12" md="9" xl="10">
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Buscar"
                single-line
                hide-details
              ></v-text-field>
            </v-col>
            <v-col>
              <v-tooltip
                bottom
                v-if="$utilFront.withPermission($prm.ADD_BRANCH_OFFICE)"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    color="primary"
                    block
                    v-bind="attrs"
                    v-on="on"
                    @click="changeAction(2)"
                  >
                    <v-icon left>mdi-plus</v-icon> Nueva sucursal
                  </v-btn>
                </template>
                <span>Agregar sucursal</span>
              </v-tooltip>
            </v-col>
          </v-row>
          <v-data-table
            :headers="headers"
            :items="list"
            :search="search"
            :items-per-page="10"
            :footer-props="{
              'items-per-page-text': 'Elementos por página',
              'items-per-page-all-text': 'Todo',
            }"
            no-results-text="Sin resultados coincidentes con la búsqueda"
            loading-text="Cargando..."
            no-data-text="Sin resultados disponibles"
            dense
            fixed-header
            height="auto"
          >
            <template v-slot:[`item.status`]="{ item }">
              <v-btn
                icon
                @click.native.prevent.stop.capture="editarStatus(item, 1)"
                :disabled="sending"
                v-if="
                  $utilFront.withPermission($prm.UPDATE_STATUS_BRANCH_OFFICE)
                "
              >
                <v-switch v-model="item.status" color="success"></v-switch>
              </v-btn>
              <span
                v-else
                :class="{
                  'error--text': !item.status,
                  'success--text': item.status,
                }"
              >
                {{ item.status ? "Activo" : "Inactivo" }}
              </span>
            </template>
            <template v-slot:[`item.principal`]="{ item }">
              <v-btn
                icon
                @click.native.prevent.stop.capture="editarStatus(item, 2)"
                :disabled="sending"
                v-if="
                  $utilFront.withPermission($prm.UPDATE_STATUS_BRANCH_OFFICE)
                "
              >
                <v-switch v-model="item.principal" color="success"></v-switch>
              </v-btn>
              <span
                v-else
                :class="{
                  'error--text': !item.principal,
                  'success--text': item.principal,
                }"
              >
                {{ item.principal ? "Principal" : "No principal" }}
              </span>
            </template>
            <template v-slot:[`item.actions`]="{ item }">
              <v-tooltip
                top
                v-if="$utilFront.withPermission($prm.UPDATE_BRANCH_OFFICE)"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    icon x-small
                    @click="checkBranchOffice(item)"
                    :disabled="sending"
                  >
                    <v-icon color="blue" v-bind="attrs" v-on="on">
                      mdi-pencil
                    </v-icon>
                  </v-btn>
                </template>
                <span>Editar información</span>
              </v-tooltip>
              <span v-else>- - -</span>
            </template>
          </v-data-table>
        </v-card-text>

        <v-card-actions class="text-center">
          <v-col
            ><export-import-btn
              texto="Importar sucursales"
              icono="import"
              color="secondary"
              @accion="askFileImport()"
          /></v-col>
          <v-col>
            <export-import-btn
              texto="Exportar sucursales"
              icono="export"
              color="green darken-1"
              @accion="exportBranchOffice()"
          /></v-col>
        </v-card-actions>
      </v-card>
      <encabezado :elementos="encabezado" v-if="showAction(2) || showAction(3)"/>
      <v-card v-if="showAction(2) || showAction(3)">
        <v-card-title>
        </v-card-title>
        <validation-observer ref="form" v-slot="{ invalid }">
          <v-form @submit.prevent="doAction">
            <div class="container" v-if="showAction(4)">modalidades</div>
            <div class="container" v-if="showAction(2) || showAction(3)">
              <v-row>
                <v-col>
                  <validation-provider
                    v-slot="{ errors }"
                    name="Nombre de sucursal"
                    rules="required|max:100"
                  >
                    <v-text-field
                      v-model="dataModal.name"
                      :counter="100"
                      :error-messages="errors"
                      :maxlength="100"
                      label="Nombre de Sucursal*"
                      required
                      autocomplete="off"
                    ></v-text-field>
                  </validation-provider>
                </v-col>
                <v-col>
                  <validation-provider
                    v-slot="{ errors }"
                    name="Clave presupuestal"
                    rules="required|max:12"
                  >
                    <v-text-field
                      v-model="dataModal.budgetKey"
                      :counter="12"
                      :maxlength="12"
                      :error-messages="errors"
                      label="Clave presupuestal*"
                      required
                      autocomplete="off"
                    ></v-text-field>
                  </validation-provider>
                </v-col>
                <v-col>
                  <validation-provider
                    v-slot="{ errors }"
                    name="Institución"
                    rules="required|max:100"
                  >
                    <v-text-field
                      v-model="dataModal.institution"
                      :counter="100"
                      :error-messages="errors"
                      :maxlength="100"
                      label="Institución*"
                      required
                      autocomplete="off"
                    ></v-text-field>
                  </validation-provider>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <validation-provider
                    v-slot="{ errors }"
                    name="Tipo de sucursal"
                    rules="required"
                  >
                    <v-select
                      v-model="dataModal.typeBranchOffice"
                      :items="listType"
                      label="Tipo de sucursal"
                      required
                      :error-messages="errors"
                    ></v-select>
                  </validation-provider>
                </v-col>
                <v-col style="text-align:center">
                    <v-btn
                      icon
                      :disabled="sending"
                      class="pa-5"
                    >
                      <v-switch v-model="dataModal.principal" label="Principal" color="success"></v-switch>
                    </v-btn>
                </v-col>
              </v-row>

              <v-row v-if="showAction(2)">
                <v-col>
                  <div
                    v-if="$utilFront.nonEmptyList(dataModal.branchOfficeList)"
                  >
                    <v-container>
                      <v-row dense>
                        <v-col
                          v-for="(item, index) in dataModal.branchOfficeList"
                          :key="index"
                          :cols="4"
                        >
                          <v-card style="border: 0.5px solid black">
                            <div>
                              <strong style="margin: 5%; color: green">{{
                                item.dayText.text
                              }}</strong
                              ><br />
                              <span
                                style="margin: 5%"
                                v-for="it in item.listHours"
                                :key="it.title"
                              >
                                <strong>{{ it.title }}:</strong>
                                {{ it.startTime }} al {{ it.endTime }}<br
                              /></span>
                              <div class="d-flex justify-center">
                                <v-btn
                                  color="error mb-4"
                                  text
                                  @click="deleteAdded(item, index, 1)"
                                >
                                  <v-icon left>mdi-close</v-icon>Remover
                                </v-btn>
                              </div>
                            </div>
                          </v-card>
                        </v-col>
                      </v-row>
                    </v-container>
                  </div>
                </v-col>
              </v-row>

              <v-row v-if="showAction(3)">
                <v-col>
                  <div
                    v-if="$utilFront.nonEmptyList(dataModal.branchOfficeList)"
                  >
                    <v-container>
                      <v-row dense>
                        <v-col
                          v-for="(item, index) in dataModal.branchOfficeList"
                          :key="index"
                          :cols="4"
                        >
                          <v-card style="border: 0.5px solid black">
                            <div>
                              <strong style="margin: 5%; color: green">{{
                                item.dayText.text
                              }}</strong
                              ><br />
                              <span
                                style="margin: 5%"
                                v-for="it in item.listHours"
                                :key="it.title"
                              >
                                <strong>{{ it.title }}:</strong>
                                {{ it.startTime }} al {{ it.endTime }}<br
                              /></span>
                              <div class="d-flex justify-center">
                                <v-btn
                                  color="error mb-4"
                                  text
                                  @click="deleteAdded(item, index, 2)"
                                >
                                  <v-icon left>mdi-close</v-icon>Remover
                                </v-btn>
                                <v-btn
                                  color="warning mb-4"
                                  text
                                  @click="editDay(item)"
                                >
                                  <v-icon left>mdi-pencil</v-icon>Seleccionar
                                </v-btn>
                              </div>
                            </div>
                          </v-card>
                        </v-col>
                      </v-row>
                    </v-container>
                  </div>
                </v-col>
              </v-row>
            </div>

            <v-divider class="mt-5"></v-divider>
            <v-subheader>Asignar modalidades</v-subheader>
            <v-row align="center" justify="center">
              <v-col cols="4">
                <validation-provider
                  v-slot="{ errors }"
                  name="Modalidades"
                  rules="required"
                >
                  <v-autocomplete
                    v-model="sModalties"
                    label="Seleccione las modalidades"
                    multiple
                    small-chips
                    :items="modaltiesList"
                    :item-text="modaltiesList.text"
                    :item-value="modaltiesList.value"
                    :error-messages="errors"
                    required
                    deletable-chips
                  ></v-autocomplete>
                </validation-provider>
              </v-col>
            </v-row>

            <div class="d-flex justify-center">
              <v-col class="d-flex justify-space-around">
                <div v-on:click="changeAction(1)">
                  <btn-accion :elements="btnCancell" />
                </div>
                <v-btn type="submit" :disabled="invalid" color="success">
                  <v-icon left>{{ iconoAdd }}</v-icon>
                  {{ textoAdd }}
                </v-btn>
              </v-col>
            </div>
          </v-form>
        </validation-observer>
      </v-card>

      <v-dialog v-model="dialog" persistent max-width="450">
        <v-card>
          <v-card-title class="text-h6 text-center">
            {{ dialogs.title }}
          </v-card-title>
          <v-card-text>{{ dialogs.text }} </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="error" text @click="dialog = false"> Cancelar </v-btn>
            <v-btn
              color="primary"
              text
              @click="
                dialog = false;
                type == 1 ? changeStatus() : changePrincipal();
              "
            >
              Aceptar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="importDialog" max-width="450">
        <v-card>
          <v-card-title class="text-h6 text-center">
            Importar sucursales
          </v-card-title>
          <v-card-text>
            <v-file-input
              accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel,text/comma-separated-values, text/csv, application/csv"
              label="Cargar archivo"
              placeholder="Seleccione un archivo"
              v-model="fileXls"
            ></v-file-input>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="error" text @click="importDialog = false">
              Cancelar
            </v-btn>
            <v-btn color="primary" text @click="importBranchOffice()">
              Cargar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="updateModal" max-width="450">
        <v-card>
          <v-card-title>
            <v-row>
              <v-col class="text-center">
                <h1>Sucursales</h1>
              </v-col>
            </v-row>
          </v-card-title>
          <v-card-text>
            <v-row class="d-flex flex-column" justify="center" align="center">
              <v-col
                class="text-center font-weight-bold title"
                :class="results.done ? 'success--text' : 'error--text'"
              >
                {{
                  results.done
                    ? "Registros cargados correctamente"
                    : "Sucedio un error al cargar los registros"
                }}
              </v-col>
              <v-col>
                <h2 class="font-weight-black">
                  <v-icon color="success" left>mdi-check-circle</v-icon>Nuevos:
                  {{ results.news }}
                </h2>
              </v-col>
              <v-col>
                <h2 class="font-weight-black">
                  <v-icon color="warning" left>mdi-circle-edit-outline</v-icon
                  >Modificados: {{ results.updates }}
                </h2>
              </v-col>
              <v-col>
                <h2 class="font-weight-black">
                  <v-icon color="error" left>mdi-alert-circle</v-icon>Errores:
                  <ul>
                    <li
                      v-for="(error, index) in results.errors"
                      :key="index"
                      class="my-3"
                    >
                      <v-icon color="warning" left>mdi-exclamation</v-icon>Error
                      {{ index + 1 }}: {{ error }}
                    </li>
                  </ul>
                </h2>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-col class="text-center">
              <v-btn text color="error" @click="updateModal = !updateModal"
                >Cerrar</v-btn
              >
            </v-col>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>
<script>
import moment from "moment";
import Datatable from "../../components/Datatable.vue";
import Encabezado from "@/app/components/base/header/Header.vue";
import Sidebar from "../../components/Sidebar";
import Loader from "@/components/Loader.vue";
import BtnAccion from "../../components/btnAccion.vue";
import { UtilFront } from "@/core/";
import {
  BranchOfficeRequest,
  BranchOfficeModalityRequest,
  EnumRequest,
  ModaltyRequest,
  ReportPDFRequest,
} from "@/core/request";
import { required, max } from "vee-validate/dist/rules";
import AutoLogout from "../../components/AutoLogout.vue";
import {
  extend,
  ValidationObserver,
  ValidationProvider,
  setInteractionMode,
} from "vee-validate";
import { mapActions } from "vuex";
import ExportImportBtn from "../../components/ExportImportBtn.vue";
setInteractionMode("eager");
extend("required", {
  ...required,
  message: "{_field_} no puede quedar vacío",
});
extend("max", {
  ...max,
  message: "{_field_} no debe ser mayor de {length} caracteres",
});

export default {
  name: "Sucursales",
  components: {
    Sidebar,
    Encabezado,
    ValidationObserver,
    ValidationProvider,
    Datatable,
    BtnAccion,
    Loader,
    AutoLogout,
    ExportImportBtn,
  },
  data() {
    return {
      dialog: false,
      importDialog: false,
      search: "",
      dataModal: {},
      objData: {},
      action: 1,
      encabezado: { icono: "mdi-hospital-building", texto: "Sucursales" },
      list: [],
      sending: false,
      dialogs: {
        title: "¿Desea modificar el estatus?",
        text: "La sucursal será habilidata / inhabilitada de inmediato y podría afectar a los registros que dependan de ella",
      },
      headers: [
        { text: "ID Sucursal", value: "idBranchOffice", align: "center"},
        { text: "Nombre", value: "name", align: "center" },
        { text: "Institución", value: "institution", align: "center" },
        { text: "Clave presupuestal", value: "budgetKey", align: "center" },
        { text: "Estatus", value: "status", align: "center" },
        { text: "Principal", value: "principal", align: "center" },
        { text: "Acciones", value: "actions", sortable: false, align: "center" },
      ],
      btnAdd: {
        icon: "mdi-plus",
        text: "Agregar Sucursal",
        tooltip: "Agregar Sucursal",
      },
      btnCancell: {
        icon: "mdi-close",
        text: "Cancelar registro",
        tooltip: "Cancelar registro",
        color: "error",
      },
      iconoAdd: "mdi-plus",
      textoAdd: "Registrar sucursal",
      service: BranchOfficeRequest,
      tab: null,
      turn1: null,
      value: 0,
      days: [],
      turns: [],
      days2: [],
      cards: [],
      branchOfficeHours: { day: null, dayText: "", listHours: [] },
      branchOfficeList: [],
      object: { title: "Matutino", startTime: "", endTime: "" },
      time: null,
      menu1: false,
      menu2: false,
      menu3: false,
      menu4: false,
      menu5: false,
      menu6: false,
      menu7: false,
      menu8: false,
      day: null,
      listDaysFull: [],
      validHours: false,
      hoursForm: true,
      showCard: false,
      listHoursOfBranchO: [],
      daysExist: [],
      modaltiesList: [],
      sModalties: [],
      idBranchOffice: "",
      updateModal: false,
      fileXls: null,
      results: {},
      type:null,
      listPrincipal: [{text: "Principal", value: 1},{text: "No principal", value: 0}],
      listType: [{text: "Central", value: "1"},{text: "Caravana", value: "2"}]
    };
  },
  created() {},
  mounted() {
    this.validBrowserTab();
    this.listAll();
    this.listEnums();
    this.getAllModalities();
  },
  methods: {
    ...mapActions(["validTab", "unauthorized"]),
    validBrowserTab() {
      this.validTab();
    },
    catchError: (e) => {
      //console.log(e);
      this.$utilFront.notifications("Ha ocurrido un error interno", "ERROR");
    },
    showAction(action) {
      return this.action == action;
    },
    editarStatus(item, type) {
      this.dialog = true;
      this.type = type;
      if(type == 1){
        this.dialogs =  {
          title: "¿Desea modificar el estatus?",
          text: "La sucursal será habilidata / inhabilitada de inmediato y podría afectar a los registros que dependan de ella",
        }
      }else{
        this.dialogs =  {
          title: "¿Desea asignar como principal?",
          text: "La sucursal será modificada",
        }
      }
      this.dataModal = Object.assign(this.dataModal, item);
    },
    changeAction(action) {
      if (action == 1) {
        this.$refs.form.reset();
        this.sModalties = [];
        this.dataModal = {};
      }
      this.action = action;
      this.checkEncabezado();
    },
    checkEncabezado() {
      switch (this.action) {
        case 1:
          this.encabezado = {
            icono: "mdi-hospital-building",
            texto: "Sucursales",
          };
          this.dialogs = {
            title: "¿Desea modificar el estatus?",
            text: "La sucursal será habilidata / inhabilitada de inmediato y podría afectar a los registros que dependan de ella",
          };
          break;
        case 2:
          this.encabezado = {
            icono: "mdi-hospital-building",
            texto: "Registrar sucursal",
          };
          this.dialogs = {
            title: "¿Desea registrar ésta sucursal?",
            text: "La sucursal será registrada de inmediato y estará disponible en el sistema",
          };
          this.iconoAdd = "mdi-plus";
          this.textoAdd = "Registrar sucursal";
          this.btnCancell = {
            icon: "mdi-close",
            text: "Cancelar registro",
            tooltip: "Cancelar registro",
            color: "error",
          };
          break;
        case 3:
          this.encabezado = {
            icono: "mdi-hospital-building",
            texto: "Editar sucursal",
          };
          this.dialogs = {
            title: "¿Desea modificar ésta sucursal?",
            text: "La sucursal será modificada de inmediato y podría afectar a los registros que dependan de ella",
          };
          this.iconoAdd = "mdi-reload";
          this.textoAdd = "Editar sucursal";
          this.btnCancell = {
            icon: "mdi-close",
            text: "Cancelar Modificación",
            tooltip: "Cancelar Modificación",
            color: "error",
          };
          break;
        default:
          this.encabezado = {
            icono: "mdi-hospital-building",
            texto: "Sucursales",
          };
          break;
      }
    },
    doAction() {
      //this.sending = !this.sending;
      if (this.$refs.form.validate()) {
        // this.dialog = true;
        if (this.action == 2) {
          this.add();
        } else if (this.action == 3) {
          this.update();
        }
      }
    },
    sendData() {
      this.sending = !this.sending;
    },
    listAll() {
      BranchOfficeRequest.allBranchOffice().then((res) => {
        if (res.data.code === 200 && res.data.status === "OK") {
          this.list = res.data.data.map((branch) => {
            return {
              idBranchOffice: branch.idBranchOffice,
              name: branch.name,
              status: branch.status,
              budgetKey: branch.budgetKey || "--- Sin información ---",
              typeBranchOffice: branch.typeBranchOffice,
              institution: branch.institution || " - - -",
              principal: branch.principal
            };
          });
        } else if (res.data.code === 401) {
          this.unauthorized();
        }
      });
    },

    listEnums() {
      EnumRequest.listAllDays().then((res) => {
        if (res.data.code === 200 && res.data.status === "OK") {
          this.days = res.data.data.map((e) => {
            return {
              text: e.text,
              value: e.value,
              disabled: false,
            };
          });
          this.listDaysFull = this.days;
        } else if (res.data.code === 401) {
          this.unauthorized();
        }
      });

      EnumRequest.listAllBranchOfficeTurn().then((res) => {
        if (res.data.code === 200 && res.data.status === "OK") {
          this.turns = res.data.data;
          this.cards = res.data.data.map((t) => {
            return {
              title: t.text,
              startTime: "",
              endTime: "",
              turn: t.value,
            };
          });
        } else if (res.data.code === 401) {
          this.unauthorized();
        }
      });
    },
    add() {
      if(!this.sending){
      this.sending = true;
      let checkList;
      if (typeof this.sModalties[0] == "object") {
        checkList = this.sModalties.map((m) => {
          return m.value;
        });
      } else {
        checkList = this.sModalties;
      }
      let postData = {
        name: this.dataModal.name.trim(),
        budgetKey: this.dataModal.budgetKey.trim(),
        // branchOfficeList: this.branchOfficeList,
        typeBranchOffice: this.objData.typeBranchOffice,
        modalities: checkList,
        institution: this.dataModal.institution,
        principal: this.dataModal.principal,
        typeBranchOffice: this.dataModal.typeBranchOffice,
      };
      
      BranchOfficeRequest.addBranchOffice(postData)
        .then((res) => {
          let { data, code, status } = res.data;
          if (code === 200 && status === "OK") {
            this.$utilFront.notifications(data, "SUCCESS");
            //this.list.unshift(data);
            this.changeAction(1);
            this.listAll();
          } else if (res.data.code === 400) {
            this.$utilFront.notifications(data, "ERROR");
            //data = data || "Ocurrió un error durante el registro.";
            //this.$utilFront.notifications("mensaje","ERROR");
          } else {
            this.$utilFront.notifications(data, "ERROR");
            //data = data || "Ocurrió un error durante el registro.";
            //this.$utilFront.notifications("mensje","ERROR");
          }
        })
        .catch(this.catchError)
        .finally(() => {
          this.sending = false;
        });
      }
    },

    update() {
      if(!this.sending){
        this.sending = true;
      let checkList;
      if (typeof this.sModalties[0] == "object") {
        checkList = this.sModalties.map((m) => {
          return m.value;
        });
      } else {
        checkList = this.sModalties;
      }
      
      let postData = {
        idBranchOffice: this.objData.idBranchOffice,
        name: this.dataModal.name,
        budgetKey: this.dataModal.budgetKey,
        status: this.objData.status,
        typeBranchOffice: this.objData.typeBranchOffice,
        modalities: checkList,
        institution: this.dataModal.institution,
        principal: this.dataModal.principal == false ? 0 : 1,
        typeBranchOffice: this.dataModal.typeBranchOffice,
      };
      BranchOfficeRequest.updateBranchOffice(postData).then((res) => {
        this.listAll();
        if (res.data.code === 200 && res.data.status === "OK") {
          this.$utilFront.notifications(
            "Sucursal modificada correctamente",
            "SUCCESS"
          );
          this.changeAction(1);
        } else if (res.data.code === 401) {
          this.unauthorized();
        } else {
          this.$utilFront.notifications(res.data.data, "ERROR");
          //this.changeAction(1);
        }
      }).finally(() => {
        this.sending = false;
      });
      }
    },

    changeStatus() {
      if(!this.sending){
      this.sending = true;
      let post = {
        idBranchOffice: this.dataModal.idBranchOffice,
      };
      BranchOfficeRequest.statusBranchOffice(post).then((res) => {
        if (res.data.data) {
          if (res.data.code === 200 && res.data.status === "OK") {
            this.list.forEach((element) => {
              if (element.idBranchOffice == this.dataModal.idBranchOffice) {
                element.status = this.dataModal.status == 0 ? 1 : 0;
              }
            });
            this.$utilFront.notifications(
              "Estatus de la sucursal cambiado con éxito",
              "SUCCESS"
            );
          } else if (res.data.code === 401) {
            this.unauthorized();
          } else {
            this.$utilFront.notifications(
              "Sucedio un error al cambiar el estatus de la sucursal",
              "ERROR"
            );
          }
        }
        
      }).finally(() => {
        this.sending = false;
      });
      }
    },
    changePrincipal() {
      if(!this.sending){
      this.sending = true;
      let post = {
        idBranchOffice: this.dataModal.idBranchOffice,
      };
      let count;
      if(this.dataModal.principal == 0){
        this.dataModal.principal == 0 ? count = 1 : count = 0;

        this.list.forEach((branch) => {
          if(branch.principal == 1){
            count++
          }
        });
      }
      
      if(count > 1){
        this.$utilFront.notifications(
              "Solo puede existir una sucursal como principal",
              "WARNING"
            );
            this.sending = false;
      }else{
        BranchOfficeRequest.principalBranchOffice(post).then((res) => {
        if (res.data.data) {
          if (res.data.code === 200 && res.data.status === "OK") {
            this.list.forEach((element) => {
              if (element.idBranchOffice == this.dataModal.idBranchOffice) {
                element.principal = this.dataModal.principal == 0 ? 1 : 0;
              }
            });
            this.$utilFront.notifications(
              "Modificación de sucursal exitosa",
              "SUCCESS"
            );
          } else if (res.data.code === 401) {
            this.unauthorized();
          } else {
            this.$utilFront.notifications(
              "Sucedio un error al modificar la sucursal",
              "ERROR"
            );
          }
        }
      }).finally(() => {
        this.sending = false;
      });
      }
      }
    },
    checkBranchOffice(item) {
      this.listEnums();
      //this.days = this.listDaysFull;
      this.showCards = true;
      this.getModaltiesByBranchOffice(item.idBranchOffice);
      this.dataModal = Object.assign(this.dataModal, item);
      Object.assign(this.objData, item);
      let data = {
        idBranchOffice: item.idBranchOffice,
      };
      BranchOfficeRequest.listHoursByBranchOfficeOrder(data)
        .then((res) => {
          let { data, status, code } = res.data;
          if (code == 200 && status == "OK") {
            this.dataModal = data;
            this.daysExist = this.dataModal.branchOfficeList.map((e) => {
              return {
                value: e.dayText.value,
                text: e.dayText.text,
                disabled: e.disabled,
              };
            });
          } else if (code == 401) {
            this.unauthorized();
          }
        })
        .catch(this.catchError)
        .finally(() => {
          //this.loader = false;
        });

      this.changeAction(3);
    },

    remove() {},
    sleep(milliseconds) {
      const date = Date.now();
      let currentDate = null;
      do {
        currentDate = Date.now();
      } while (currentDate - date < milliseconds);
    },

    resetForm() {
      this.branchOfficeHours = { day: null, dayText: "", listHours: [] };
      this.cards = this.turns.map((t) => {
        return {
          title: t.text,
          startTime: "",
          endTime: "",
          turn: t.value,
        };
      });
      this.day = null;
      this.dayText = null;
      this.$refs.hoursForm.reset();
    },
    validatePresForm(day) {
      let bar = this.$refs.hoursForm.validate();
      return bar && day != null;
    },
    addToList(type) {
      try {
        if (type == 1) {
          if (this.validatePresForm(this.day)) {
            this.branchOfficeHours.day = this.day;
            this.branchOfficeHours.dayText = this.days.find((i) => {
              if (i.value == this.day) {
                return i.text;
              }
            });
            this.cards.map((d) => {
              d.startTime = d.startTime + ":00";
              d.endTime = d.endTime + ":00";
            });
            this.branchOfficeHours.listHours = this.cards;

            this.branchOfficeList.push(this.branchOfficeHours);
            this.days.map((e) => {
              e.value == this.day ? (e.disabled = true) : "";
            });
          }
        } else {
          this.dataModal.branchOfficeHours.day = this.day;
          this.dataModal.branchOfficeHours.dayText = this.days.find((i) => {
            if (i.value == this.day) {
              return i.text;
            }
          });
          this.cards.map((d) => {
            d.startTime = d.startTime + ":00";
            d.endTime = d.endTime + ":00";
          });
          this.branchOfficeHours.listHours = this.cards;

          this.branchOfficeList.push(this.branchOfficeHours);
          this.days.map((e) => {
            e.value == this.day ? (e.disabled = true) : "";
          });
        }
      } catch (e) {
      } finally {
        this.resetForm();
      }
    },

    deleteAdded(item, index, type) {
      //this.listEnums();
      //this.days = this.listDaysFull;
      if (type == 1) {
        let remove = this.branchOfficeList.splice(index, 1);
        this.days.map((e) => {
          e.value == remove[0].dayText.value ? (e.disabled = false) : "";
        });
      } else {
        let remove = this.dataModal.branchOfficeList.splice(index, 1);
      }
    },
    addPatologico() {
      this.newPatologico.push(this.objPato);
      this.days.forEach((value, index, array) => {
        if (value.text === this.objPato) value.disabled = true;
      });
      this.objPato = "";
    },
    removePato(item, dayValue) {
      let i = this.newPatologico.indexOf(item);
      this.days.forEach((value, index, array) => {
        if (value.text === this.newPatologico[i]) value.disabled = false;
      });
      if (i > -1) this.newPatologico.splice(i, 1);
    },

    after(value, val2) {
      return value > val2 ? "mayor" : "menor";
    },
    editDay(item) {
      //this.card[0].startTime = item.listHours.startTime;
    },
    listHoursByBranchOffice() {
      BranchOfficeRequest.listHoursByBranchOffice(data)
        .then((res) => {})
        .catch(e);
    },
    editModalities(item) {
      try {
        this.sending = true;
      } catch (error) {
        this.catchError(error);
      }
    },

    getAllModalities() {
      ModaltyRequest.allModality().then((res) => {
        if (res.data.code === 200 && res.data.status === "OK") {
          this.modaltiesList = res.data.data.map((mod) => {
            let modName = `${mod.acronym} - ${mod.name}`;
            return {
              value: mod.idModality,
              text: modName,
            };
          });
        }
      });
    },
    getModaltiesByBranchOffice(idBranchOffice) {
      BranchOfficeModalityRequest.listAllByBranchOffice({
        idBranchOffice: idBranchOffice,
      }).then((res) => {
        this.sModalties = res.data.data.map((mod) => {
          let modName = `${mod.acronym} - ${mod.name}`;
          return {
            value: mod.idModality,
            text: modName,
          };
        });
      });
    },
    askFileImport() {
      this.importDialog = !this.importDialog;
    },
    exportBranchOffice() {
      this.sending = true;

      ReportPDFRequest.exportTempleteBranchOffice()
        .then((res) => {
          const url = URL.createObjectURL(
            new Blob([res.data], {
              type: "application/vnd.ms-excel",
            })
          );

          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "Sucursales.xlsx");
          document.body.appendChild(link);
          link.click();
        })
        .finally(() => {
          this.sending = false;
        });
    },
    importBranchOffice() {
      this.importDialog = !this.importDialog;

      if (this.fileXls) {
        this.sending = true;

        const formData = new FormData();

        formData.append("file", this.fileXls);

        ReportPDFRequest.importTempleteBranchOffice(formData)
          .then((res) => {
            res.data.text().then((texto) => {
              const { done, errors, news, updates } = JSON.parse(texto).data;

              this.results = JSON.parse(texto).data;

              if (done) {
                this.listAll();
                this.fileXls = null;
              }

              this.updateModal = true;
            });
          })
          .finally(() => {
            this.sending = false;
          });
      }
    },
  },
};
</script>